import { render } from "./FlangerContent.vue?vue&type=template&id=de4e2a1c&scoped=true"
import script from "./FlangerContent.vue?vue&type=script&lang=js"
export * from "./FlangerContent.vue?vue&type=script&lang=js"

import "./FlangerContent.vue?vue&type=style&index=0&id=de4e2a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4e2a1c"]])

export default __exports__